import styled from "styled-components";

export const StyledDiv = styled.div`
  > div {
    display: flex;
    align-items: center;
    gap: 24px;
    padding-bottom: 24px;
  }
`;
